import CustomInputToolbar from './CustomInputToolbar';

export default CustomInputToolbar;
